import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  apiUrl: string;
  hostUrl: string;
  /** Marketing/landing URL — `bilety.dibsondance.com` family. */
  joinProUrl?: string;
  /**
   * Customer-facing portal base URL — `dibsondance.com` family. Used by
   * the host UI to build cross-origin URLs that point at the portal SSR
   * (e.g. the DOD-190 embed widget iframe src).
   */
  portalUrl?: string;
  buildTimestamp?: string;
  buildUnixTime?: string;
  buildNumber?: string;
  googleMapsApiKey?: string;
  geocodingApiKey?: string;
  /**
   * DOD-638 — store listings for the Check-In scanner app, mirrored from the
   * backend's `/hosts/self/offerings/{id}/check-in/config`. Host-only; the
   * portal has no scanner page.
   */
  scanner?: {
    iosUrl: string;
    androidUrl: string;
  };
  /**
   * DOD-140 — launch gates for features that are built but not yet public.
   *
   * Optional, and every flag inside it optional, so an environment that has
   * never heard of a flag reads as "off". `app.config.ts` copies environment
   * keys into `EnvironmentService` by hand, and a key left out of that list is
   * silently `undefined` — this shape makes that mistake fail safe.
   *
   * Not a security control: the backend gates the transfer API with its own
   * `feature.flag.pass_transfer_enabled`. This only decides whether the UI
   * is reachable.
   */
  features?: {
    /** Pass transfer — sender wizard and recipient acceptance (DOD-140). */
    passTransfer?: boolean;
  };
}

export const ENVIRONMENT_SERVICE = new InjectionToken<EnvironmentService>(
  'ENVIRONMENT_SERVICE'
);

export class EnvironmentService {
  private readonly runtimeTimestamp: string;

  constructor(public readonly environment: Environment) {
    this.runtimeTimestamp = Date.now().toString();
  }

  get translationCacheVersion(): string {
    return this.runtimeTimestamp;
  }
}
